export const selectFactoryTypes = (state) => state.factoryTypes.types;

export const selectFactoryTypesLoading = (state) => state.factoryTypes.loading;
export const selectFactoryTypesError = (state) => state.factoryTypes.error;